import Sdata from '@/database/sdata'

let g_entity = 'caisse_terminal'
let g_url    = 'studio/terminal'
let g_pkey   = ['uid']
Sdata.addConfig( g_entity, g_pkey, g_url )

export default class Terminal extends Sdata
{
  static entity = g_entity
  static url    = g_url
}